import { useState, useEffect, useRef } from "react";

export const useCarousel = (totalItems: number) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const autoScrollRef = useRef<NodeJS.Timeout | null>(null);

  const handleNext = () => {
    setCurrentIndex((prev) => {
      if (prev === totalItems - 4) {
        return 0;
      } else if (prev === totalItems - 1) {
        return 1;
      } else {
        return prev + 1;
      }
    });
  };

  useEffect(() => {
    const startAutoScroll = () => {
      autoScrollRef.current = setInterval(() => {
        if (!isPaused) {
          handleNext();
        }
      }, 5000);
    };

    startAutoScroll();

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
      }
    };
  }, [isPaused]);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return {
    currentIndex,
    setCurrentIndex,
    handleMouseEnter,
    handleMouseLeave,
  };
};
